import { render, staticRenderFns } from "./RestorantsConstructior.vue?vue&type=template&id=1599c50a&scoped=true&"
import script from "./RestorantsConstructior.vue?vue&type=script&lang=ts&"
export * from "./RestorantsConstructior.vue?vue&type=script&lang=ts&"
import style0 from "./RestorantsConstructior.vue?vue&type=style&index=0&id=1599c50a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1599c50a",
  null
  
)

export default component.exports